import * as React from "react";
import CustomField from "../../../model/customField/CustomField";
import {notifyBugsnagAndShowToast} from "../../../utils/Utils";
import {Dispatch} from "redux";
import {fetchJobCustomFields} from "../../../store/action/customField/customField";
import {RootState} from "../../../store/reducer/root/RootState";
import {connect} from "react-redux";
import {none, option, Option} from "ts-option";
import Toast from "../../helper/Toast";
import CustomFieldsDisplay from "../../admin/customFields/CustomFieldsDisplay";
import CustomFieldValue from "../../../model/job/CustomFieldValue";
import {OnSuccess} from "../../../store/action/actionHelpers";

interface ComponentProps {
	/**
	 * Job custom fields values
	 */
	jobCustomFieldsValues: Option<CustomFieldValue[]>
	/**
	 * Create job custom field value
	 * @param {CustomFieldValue} createdCustomFieldValue
	 * @param {OnSuccess} onSuccess
	 */
	createJobCustomFieldValue: (createdCustomFieldValue: CustomFieldValue, onSuccess: OnSuccess) => void;
	/**
	 * Update job custom field value
	 * @param {CustomFieldValue} updatedCustomFieldValue
	 * @param {OnSuccess} onSuccess
	 */
	updateJobCustomFieldValue: (updatedCustomFieldValue: CustomFieldValue, onSuccess: OnSuccess) => void;
	/**
	 * Remove job custom field value
	 * @param {string} customFieldValueId
	 * @param {OnSuccess} onSuccess
	 */
	removeJobCustomFieldValue: (customFieldValueId: string, onSuccess: OnSuccess) => void;
}

interface IDispatchProps {
	/**
	 * Fetch job custom fields method
	 */
	fetchJobCustomFields: () => void;
}

interface ReduxProps {
	/**
	 * Job custom fields list.
	 */
	jobCustomFields: Option<CustomField[]>;
}

type Props = IDispatchProps & ReduxProps & ComponentProps;

class JobCustomFields extends React.Component<Props> {
	constructor(props: Props) {
		super(props);
		this.updateCustomFieldValue = this.updateCustomFieldValue.bind(this);
		this.removeCustomFieldValue = this.removeCustomFieldValue.bind(this);
		this.createCustomFieldValue = this.createCustomFieldValue.bind(this);
	}

	render() {
		return (
			<CustomFieldsDisplay customFields={this.props.jobCustomFields}
								 customFieldsValues={this.props.jobCustomFieldsValues}
								 fetchCustomFields={this.props.fetchJobCustomFields}
								 createCustomFieldValue={this.createCustomFieldValue}
								 updateCustomFieldValue={this.updateCustomFieldValue}
								 removeCustomFieldValue={this.removeCustomFieldValue}/>
		)
	}

	createCustomFieldValue(createdCustomFieldValue:CustomFieldValue) {
		this.props.createJobCustomFieldValue(createdCustomFieldValue, this.onCreateSuccess);
	}

	onCreateSuccess() {
		return Toast.success('Job custom field value created', 'Job custom field create');
	}

	updateCustomFieldValue(updatedCustomFieldValue: CustomFieldValue) {
		this.props.updateJobCustomFieldValue(updatedCustomFieldValue, this.onUpdateSuccess);
	}

	onUpdateSuccess() {
		return Toast.success('Job custom field value updated', 'Job custom field update');
	}

	removeCustomFieldValue(customFieldValueId: string) {
		this.props.removeJobCustomFieldValue(customFieldValueId, this.onRemoveSuccess)
	}

	onRemoveSuccess() {
		return Toast.success('Job custom field value removed', 'Job custom field removed');
	}
}

function mapDispatchToProps(dispatch: Dispatch<any>) {
	return {
		fetchJobCustomFields: () => dispatch(
			fetchJobCustomFields(() => {}, (error) => notifyBugsnagAndShowToast(error, "Fetch job custom fields"))
		)
	};
}

function mapStateToProps(state: RootState) {
	const filtered = state.customFields.jobCustomFields.getOrElse([]).filter(item => !item.disabledInUi);
	return {
		jobCustomFields: state.customFields.jobCustomFields.isDefined ? option(filtered) : none
	}
}

export default connect(mapStateToProps, mapDispatchToProps)(JobCustomFields)